import { ActivityService } from '../services/ActivityService';

export const getActivitiesList = async (activeFiltre) => {
	const { status, data } = await ActivityService.getActivitiesList(
		activeFiltre,
	);
	if (status === 200) {
		return data;
	}
	return false;
};

export const updateActivityStatus = async (activity) => {
	const { nuint, readStatus, processStatus } = activity;
	const { status, data } = await ActivityService.updateActivityStatus(
		nuint,
		readStatus,
		processStatus,
	);
	if (status === 201) {
		return data;
	}
	return false;
};

export const getDocumentContent = async (token) => {
	const { status, data } = await ActivityService.getDocumentContent(token);
	if (status === 200) {
		return data;
	}
	return false;
};

export function getBase64(file) {
	return new Promise((resolve) => {
		const reader = new FileReader();
		// eslint-disable-next-line func-names
		reader.onloadend = function () {
			resolve(reader.result);
		};
		reader.readAsDataURL(file);
	});
}

export const uploadDocument = async (params) => {
	const { status, data } = await ActivityService.uploadDocument(params);
	if (status === 201) {
		return data;
	}
	return false;
};

export const confirmationSendDocument = async (params) => {
	const { status, data } = await ActivityService.confirmationSendDocument(
		params,
	);
	if (status === 201) {
		return data;
	}
	return false;
};

export const addActivityComment = async (commentData) => {
	const { nuint, comment, sendComment } = commentData;
	const { status, data } = await ActivityService.addComment(
		nuint,
		comment,
		sendComment,
	);
	if (status === 201) {
		return data;
	}
	return false;
};

export const getUniqueResourcesFromActivities = (activities) => {
	const resources = [];
	activities.forEach((activity) => {
		if (!resources.includes(activity?.resource?.name)) {
			resources.push(activity.resource.name);
		}
	});

	// format the array
	if (resources.length > 0) {
		return resources.map((resource, index) => ({
			id: index,
			name: resource,
			selected: true,
		}));
	}

	return resources;
};

export const filterActivities = (activity, filters) => {
	const selectedResources = filters.resources.filter(
		(resource) => resource.selected,
	);

	const checkBoxTreated = filters.treatments[0].selected;
	const checkBoxUntreated = filters.treatments[1].selected;

	let isSelectedActivity = false;

	if (
		selectedResources.length > 0 &&
		(checkBoxTreated || checkBoxUntreated)
	) {
		isSelectedActivity = selectedResources.some(
			(resource) => activity.resource.name === resource.name,
		);
		const { processStatus } = activity;
		if (isSelectedActivity) {
			if (checkBoxTreated && !checkBoxUntreated && !processStatus) {
				isSelectedActivity = false;
			} else if (!checkBoxTreated && checkBoxUntreated && processStatus) {
				isSelectedActivity = false;
			}
		}
	}

	// filter activities by search text (multiple words are allowed to be searched at the same time)
	if (filters.search && filters.search?.length > 0 && isSelectedActivity) {
		const searchText = filters.search.toLowerCase();
		const searchWords = searchText.split(' ');
		const activityText = `${activity.project} ${activity.nuint} ${activity.resource.name} ${activity.activityType} ${activity.customer.name} ${activity.customer.address} ${activity.customer.city} ${activity.customer.zipCode} ${activity.week}`;

		isSelectedActivity = searchWords.every((word) =>
			activityText.toLowerCase().includes(word),
		);
	}

	return isSelectedActivity;
};
